import { ConfirmationDialog } from '@statsbomb/kitbag-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NameInput } from '@/components/input/NameInput';
import { CONFIG_NAME_MAX_LENGTH } from '@/consts/userConfigs';

export const GenericSaveModal = ({
  id,
  title,
  onConfirm,
  onCancel,
  confirmLabel,
  value,
  onChange,
  existingConfigNames,
}: {
  id: string;
  title: string;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
  confirmLabel: string;
  value: string;
  onChange: (newValue: string) => void;
  existingConfigNames: string[];
}) => {
  const { t } = useTranslation(['general', 'input']);
  const [isLoading, setIsLoading] = useState(false);

  const isEmptyValue = value.trim() === '';
  const isTooLong = value.length > CONFIG_NAME_MAX_LENGTH;
  const isValueTaken = existingConfigNames.includes(value);

  const isDisabledConfirm = isEmptyValue || isTooLong || isValueTaken;

  const getErrorMessage = () => {
    if (isTooLong) return t('name.error.maxLength', { ns: 'input', max: CONFIG_NAME_MAX_LENGTH });
    if (isValueTaken) return t('name.error.alreadyExists', { ns: 'input' });

    return undefined;
  };
  const errorMessage = getErrorMessage();

  return (
    <ConfirmationDialog
      id={id}
      testId={id}
      title={title}
      isOpen
      onConfirm={async () => {
        setIsLoading(true);
        await onConfirm();
        setIsLoading(false);
      }}
      onCancel={onCancel}
      cancelLabel={t('cancel')}
      confirmLabel={confirmLabel}
      isDisabledConfirm={isDisabledConfirm}
      isPendingConfirm={isLoading}
    >
      <div className="sm:min-w-[400px] md:min-w-[450px]">
        <NameInput
          id={`${id}-input`}
          value={value}
          onChange={e => onChange(e.target.value)}
          errorMessage={errorMessage}
          autoFocus
        />
      </div>
    </ConfirmationDialog>
  );
};
